import React, { useState, useEffect } from "react";
import { Course as CourseController } from "../../../api";
import { Container, Image, Button } from "semantic-ui-react";
import { map } from "lodash";
import { image } from "../../../assets";
import { Course } from "../../../components/Web/Courses";
import "./Courses.scss";

const courseController = new CourseController();

export function Courses() {
  const [courses, setCourses] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  const isCurrentLastPage = pagination?.page === pagination?.pages;

  useEffect(() => {
    (async () => {
      try {
        const response = await courseController.getCourses({ page, limit: 9 });
        setPagination({
          page: response.courses.page,
          pages: response.courses.totalPages,
        });

        setCourses((prevCourses) => {
          if (!prevCourses) {
            return response.courses.docs;
          } else {
            return [...prevCourses, ...response.courses.docs];
          }
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page]); // Dependencias: solo depende de `page`

  const loadMore = () => {
    setPage((prevState) => prevState + 1);
  };

  return (
    <Container className="courses-page">
      <Image src={image.academyLogo} />
      <h2>
        En esta web encontraras los mejores cursos online de programacion,
        diseño, marketing y mucho mas
      </h2>
      <div className="courses">
        {map(courses, (course) => (
          //console.log("course._id", course._id),
          <div key={course._id} className="courses__item">
            <Course course={course} />
          </div>
        ))}
      </div>

      {!isCurrentLastPage && (
        <div className="more">
          <Button primary onClick={loadMore}>
            Ver mas cursos
          </Button>
        </div>
      )}
    </Container>
  );
}
